import SmartAnalyzer from './SmartAnalyzer';
export default SmartAnalyzer;
